import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Td = React.forwardRef((props, ref) => {
    const { children, className, asElement: Component, ...rest } = props

    const tdClass = classNames(Component !== 'td' && 'td', className, 'border-b dark:text-white border-gray-200 dark:border-custom-100')

    return (
        <Component className={tdClass} ref={ref} {...rest}>
            {children}
        </Component>
    )
})

Td.propTypes = {
    asElement: PropTypes.string,
}

Td.defaultProps = {
    asElement: 'td',
}

export default Td
